import React, { useEffect, useMemo, useState } from 'react';
import {
  SimpleView,
  GridView,
  Widget,
  FormInput,
  Table,
  Button,
  FormSelect,
  FilterWidget,
  FormContext,
  FormRangePicker,
  ColumnProps,
  Form,
  Row,
  Col,
  FormResetButton,
  FormSubmitButton,
  CompositeView,
} from '@digital/ui';
import { Icon } from 'antd';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getClassificacaoServicoForOptions } from '@app/api/classificacaoServico';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasByDiretoriaOptions } from '@app/api/area';
import { getAllDepartamentoProAreaIdOptions, getAllDepartamentoProDiretoriaIdOptions } from '@app/api/departamento';
import { GetRelatorioControleGastos, GetRelatorioControleGastosExcel } from '@app/api/relatorioClassificacaoGastos';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { thousandSeparator } from '@app/helpers/numbers';
import { getAllTipoLinhaPlanilhaRateioOptions } from '@app/api/planilhaRateio';
import { compareDates, compareNumber, compareText } from '@app/helpers/comparators';
import moment from 'moment';

const RelatorioClassificacaoGastos = () => {
  const [optionsNivel1, setOptionsNivel1] = useState([]);
  const [optionsNivel2, setOptionsNivel2] = useState([]);
  const [optionsNivel3, setOptionsNivel3] = useState([]);

  const [optionsDiretoria, setOptionsDiretoria] = useState([]);
  const [optionsArea, setOptionsArea] = useState([]);
  const [optionsDepartamento, setOptionsDepartamento] = useState([]);

  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    handleFilter({});
  }, []);

  //#region Populate filter options

  useEffect(() => {
    getClassificacaoServicoForOptions().then(data => setOptionsNivel1(data));
    getOptionsDiretoria();
  }, []);

  const getOptionsNivel2 = (idPai: string) => {
    getClassificacaoServicoForOptions(idPai).then(data => setOptionsNivel2(data));
  };

  const getOptionsNivel3 = (idPai: string) => {
    getClassificacaoServicoForOptions(idPai).then(data => setOptionsNivel3(data));
  };

  const getOptionsDiretoria = () => {
    getAllDiretoriasOptions().then(data => setOptionsDiretoria(data));
  };

  const getOptionsArea = (diretoriaId: string) => {
    getAllAreasByDiretoriaOptions(diretoriaId).then(data => setOptionsArea(data));
  };

  const getOptionsDepartamentoByArea = (areaId: string) => {
    getAllDepartamentoProAreaIdOptions(areaId).then(data => setOptionsDepartamento(data));
  };

  const getOptionsDepartamentoByDiretoria = (areaId: string) => {
    getAllDepartamentoProDiretoriaIdOptions(areaId).then(data => setOptionsDepartamento(data));
  };

  //#endregion

  const handleFilter = async (values: any) => {
    GetRelatorioControleGastos(values).then(data => {
      setData(data);
    });
  };
  const handleExcel = async (values: any) => {
    GetRelatorioControleGastosExcel(values);
  };

  const columns = useMemo(() => {
    const columns: ColumnProps<any>[] = [];

    columns.push({
      title: 'Nº Contrato',
      dataIndex: 'contrato',
      width: '8%',
      sorter: (a, b) => compareNumberString(a.contrato, b.contrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nº Contrato"
              name="contrato"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.contrato && record.contrato.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Contratada',
      dataIndex: 'contratada',
      width: '15%',
      sorter: (a, b) => compareText(a.contratada, b.contratada),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Contratada"
              name="contratada"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.contratada && record.contratada.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Dir',
      dataIndex: 'diretoria',
      width: '3%',
      sorter: (a, b) => compareText(a.diretoria, b.diretoria),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Diretoria"
              name="diretoria"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.diretoria && record.diretoria.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Área',
      dataIndex: 'area',
      width: '3%',
      sorter: (a, b) => compareText(a.area, b.area),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Área"
              name="area"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => record.area && record.area.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Dep',
      dataIndex: 'departamento',
      width: '3%',
      sorter: (a, b) => compareText(a.departamento, b.departamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Departamento"
              name="departamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.departamento && record.departamento.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Nível 1',
      dataIndex: 'nivel1',
      width: '5%',
      sorter: (a, b) => compareText(a.nivel1, b.nivel1),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nível 1"
              name="nivel1"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.nivel1 && record.nivel1.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Nível 2',
      dataIndex: 'nivel2',
      width: '5%',
      sorter: (a, b) => compareText(a.nivel2, b.nivel2),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nível 2"
              name="nivel2"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.nivel2 && record.nivel2.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Nível 3',
      dataIndex: 'nivel3',
      width: '5%',
      sorter: (a, b) => compareText(a.nivel3, b.nivel3),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nível 3"
              name="nivel3"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.nivel3 && record.nivel3.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'BM',
      dataIndex: 'medicaoNumero',
      width: '1%',
      sorter: (a, b) => compareNumberString(a.medicaoNumero, b.medicaoNumero),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar BM"
              name="medicaoNumero"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.medicaoNumero && record.medicaoNumero.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push(
      {
        title: 'PQ',
        dataIndex: 'identificadorPQ',
        width: '5%',
        sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar PQ"
                name="identificadorPQ"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
  
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.identificadorPQ &&
          record.identificadorPQ
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      }
    );

    columns.push({
      title: 'Tipo de Despesa',
      dataIndex: 'tipoDespesa',
      sorter: (a, b) => compareText(a.tipoDespesa, b.tipoDespesa),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo de Despesa"
              name="tipoDespesa"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.tipoDespesa && record.tipoDespesa.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Natureza',
      dataIndex: 'natureza',
      sorter: (a, b) => compareNumberString(a.natureza, b.natureza),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Natureza"
              name="natureza"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.natureza && record.natureza.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Descrição da Natureza',
      dataIndex: 'descricaoNatureza',
      sorter: (a, b) => compareText(a.descricaoNatureza, b.descricaoNatureza),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Descrição da Natureza"
              name="descricaoNatureza"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.descricaoNatureza && record.descricaoNatureza.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Número',
      dataIndex: 'numero',
      sorter: (a, b) => compareNumberString(a.numero, b.numero),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Número"
              name="numero"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numero && record.numero.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Descrição Número',
      dataIndex: 'descricaoNumero',
      sorter: (a, b) => compareText(a.descricaoNumero, b.descricaoNumero),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Descrição Número"
              name="descricaoNumero"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.descricaoNumero && record.descricaoNumero.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Valor',
      dataIndex: 'valor',
      render: (text, record) => 'R$ ' + thousandSeparator(record.valor),
      width: '8%',
    });

    columns.push({
      title: 'Período Início',
      dataIndex: 'periodoInicio',
      render: (text, record) => moment(record.periodoInicio).format(dateFormat),
      width: '10%',
      sorter: (a, b) =>
        compareDates(moment(a.periodoInicio).format(dateFormat), moment(b.periodoInicio).format(dateFormat)),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Período Início"
              name="periodoInicio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.periodoInicio !== undefined &&
        moment(record.periodoInicio).format(dateFormat).toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Periodo Fim',
      dataIndex: 'periodoFim',
      render: (text, record) => moment(record.periodoFim).format(dateFormat),
      width: '10%',
      sorter: (a, b) => compareDates(moment(a.periodoFim).format(dateFormat), moment(b.periodoFim).format(dateFormat)),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Periodo Fim"
              name="periodoFim"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.periodoFim !== undefined &&
        moment(record.periodoFim).format(dateFormat).toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Data Conclusão Bm',
      dataIndex: 'dataConclusaoBm',
      render: (text, record) => moment(record.dataConclusaoBm).format(dateFormat),
      width: '15%',
      sorter: (a, b) =>
        compareDates(moment(a.dataConclusaoBm).format(dateFormat), moment(b.dataConclusaoBm).format(dateFormat)),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data Conclusão Bm"
              name="dataConclusaoBm"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataConclusaoBm !== undefined &&
        moment(record.dataConclusaoBm).format(dateFormat).toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Município',
      dataIndex: 'municipio',
      sorter: (a, b) => compareText(a.municipio, b.municipio),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Município"
              name="municipio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.municipio && record.municipio.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Data Autorização',
      dataIndex: 'dataAutorizacao',
      render: (text, record) => moment(record.dataAutorizacao).format(dateFormat),
      width: '10%',
      sorter: (a, b) =>
        compareDates(moment(a.dataAutorizacao).format(dateFormat), moment(b.dataAutorizacao).format(dateFormat)),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data Autorização"
              name="dataAutorizacao"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataAutorizacao !== undefined &&
        moment(record.dataAutorizacao).format(dateFormat).toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Data Emissão Doc Cobrança',
      dataIndex: 'dataEmissaoDocCobranca',
      render: (text, record) => moment(record.dataEmissaoDocCobranca).format(dateFormat),
      width: '10%',
      sorter: (a, b) =>
        compareDates(
          moment(a.dataEmissaoDocCobranca).format(dateFormat),
          moment(b.dataEmissaoDocCobranca).format(dateFormat),
        ),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data Emissão Doc Cobrança"
              name="dataEmissaoDocCobranca"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataEmissaoDocCobranca !== undefined &&
        moment(record.dataEmissaoDocCobranca).format(dateFormat).toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Previsão Pagto',
      dataIndex: 'previsaoPgto',
      render: (text, record) => moment(record.previsaoPgto).format(dateFormat),
      width: '12%',
      sorter: (a, b) =>
        compareDates(moment(a.previsaoPgto).format(dateFormat), moment(b.previsaoPgto).format(dateFormat)),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Previsão Pagto"
              name="previsaoPgto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.previsaoPgto !== undefined &&
        moment(record.previsaoPgto).format(dateFormat).toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Status Pagto',
      dataIndex: 'statusPgto',
      sorter: (a, b) => compareText(a.statusPgto, b.statusPgto),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status Pagto"
              name="statusPgto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusPgto && record.statusPgto.toString().toLowerCase().includes(value.toLowerCase()),
    });

    columns.push({
      title: 'Tipo Documento Cobrança',
      dataIndex: 'tipoDocumentoCobranca',
      sorter: (a, b) => compareText(a.tipoDocumentoCobranca, b.tipoDocumentoCobranca),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Tipo Documento Cobrança"
              name="tipoDocumentoCobranca"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.tipoDocumentoCobranca &&
        record.tipoDocumentoCobranca.toString().toLowerCase().includes(value.toLowerCase()),
    });

    return columns;
  }, [data]);

  return (
    <CompositeView>
      <SimpleView>
        <GridView onSubmit={handleFilter}>
          <FormContext.Consumer>
            {({ formProps }) => (
              <FilterWidget
                active={[]}
                actions={[
                  <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
                  <Button
                    type="primary"
                    title="Limpar Filtro"
                    onClick={() => {
                      setOptionsArea([]);
                      setOptionsDepartamento([]);
                      setOptionsNivel2([]);
                      setOptionsNivel3([]);
                      formProps.resetForm();
                    }}
                  />,
                  <Button
                    type="primary"
                    title="Pesquisar"
                    key="filterBtn"
                    onClick={() => handleFilter(formProps.values)}
                  />,
                ]}
                title="Filtros">
                <>
                  <FormRangePicker
                    startName="periodoAutorizacaoFaturamentoStart"
                    endName="periodoAutorizacaoFaturamentoEnd"
                    span={4}
                    label="Período de Autorização de Faturamento"
                  />
                  <FormInput name="contrato" span={4} label="Contrato" />
                  <FormInput name="natureza" span={4} label="Natureza" />
                  <FormSelect
                    options={optionsDiretoria}
                    onChange={e => {
                      getOptionsDepartamentoByDiretoria(e.toString());
                      getOptionsArea(e.toString());
                      formProps.setFieldValue('area', undefined);
                      formProps.setFieldValue('departamento', undefined);
                    }}
                    name="diretoria"
                    span={4}
                    label="Diretoria"
                  />
                  <FormSelect
                    options={optionsArea}
                    onChange={e => {
                      getOptionsDepartamentoByArea(e.toString());
                      formProps.setFieldValue('departamento', undefined);
                    }}
                    name="area"
                    span={4}
                    label="Área"
                  />
                  <FormSelect options={optionsDepartamento} name="departamento" span={4} label="Departamento" />
                  <FormSelect
                    options={optionsNivel1}
                    onChange={e => getOptionsNivel2(e.toString())}
                    name="classificacaoNivel1"
                    span={4}
                    label="Nível 1"
                  />
                  <FormSelect
                    options={optionsNivel2}
                    onChange={e => getOptionsNivel3(e.toString())}
                    name="classificacaoNivel2"
                    span={4}
                    label="Nível 2"
                  />
                  <FormSelect options={optionsNivel3} name="classificacaoNivel3" span={4} label="Nível 3" />
                  <FormSelect
                    getOptions={getAllTipoLinhaPlanilhaRateioOptions}
                    name="tipoDespesa"
                    mode="multiple"
                    span={4}
                    label="Tipo de Despesa"
                  />
                </>
              </FilterWidget>
            )}
          </FormContext.Consumer>

          <Widget title="Relatório de Classificação de Gastos">
            <PerfectScrollbar>
              <Table
                className="no-bold-table on-table-overflow"
                columns={columns}
                dataSource={data || []}
                rowKey={'id'}
                pagination={{pageSize: 100}}
              />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};
export default RelatorioClassificacaoGastos;
